export default __webpack_public_path__ + "img/985034240f6f6cb7587471171e40ee24.png";